import restApi from '../http-common';
import session from "../services/session";

export default class OpenApi {

    getOrder(orderId) {
        return restApi({
            method: 'get',
            url: '/api/integration/orders/' + orderId,
        })
    }


}



// WEBPACK FOOTER //
// ./src/services/openApi.js